const roomData = {
    "CN": {
        name: "Control Nexus",
        background: "rgba(58, 107, 175, 0.25)",
        border: "#2f4f7a"
    },
    "MFG": {
        name: "Manufacturing Cabin",
        background: "rgba(217, 184, 74, 0.25)",
        border: "#c4a83c",
        items: {
            "Advanced_Combat_Record": {
                name: "Advanced Combat Record",
                duration: 35200,
                type: "operator xp",
                value: 10000
            },
            "Elementary_Combat_Record": {
                name: "Elementary Combat Record",
                duration: 920,
                type: "operator xp",
                value: 200,
            },
            "Intermediate_Combat_Record": {
                name: "Intermediate Combat Record",
                duration: 4200,
                type: "operator xp",
                value: 1000
            },
            "Elementary_Cognitive_Carrier": {
                name: "Elementary Cognitive Carrier",
                duration: 10500,
                type: "operator xp",
                value: 1000
            },
            "Advanced_Cognitive_Carrier": {
                name: "Advanced Cognitive Carrier",
                duration: 88000,
                type: "operator xp",
                value: 10000
            },
            "Arms_Inspector": {
                name: "Arms Inspector",
                duration: 920,
                type: "weapon xp",
                value: 200
            },
            "Arms_INSP_Kit": {
                name: "Arms INSP Kit",
                duration: 4200,
                type: "weapon xp",
                value: 1000
            },
            "Arms_INSP_Set": {
                name: "Arms INSP Set",
                duration: 35200,
                type: "weapon xp",
                value: 10000
            }
        }
    },
    "GC": {
        name: "Growth Chamber",
        background: "rgba(109, 174, 95, 0.25)",
        border: "#5c9e4b",
        items: {
            "Pink_Bolete": {
                name: "Pink Bolete",
                duration: 62500,
                type: "fungus"
            },
            "Red_Bolete": {
                name: "Red Bolete",
                duration: 100000,
                type: "fungus"
            },
            "Ruby_Bolete": {
                name: "Ruby Bolete",
                duration: 220000,
                type: "fungus"
            },
            "Bloodcap": {
                name: "Bloodcap",
                duration: 450000,
                type: "fungus"
            },
            "Cosmagaric": {
                name: "Cosmagaric",
                duration: 450000,
                type: "fungus"
            },
            "Kalkodendra": {
                name: "Kalkodendra",
                duration: 62500,
                type: "plant"
            },
            "Chrysodendra": {
                name: "Chrysodendra",
                duration: 100000,
                type: "plant"
            },
            "Vitrodendra": {
                name: "Vitrodendra",
                duration: 220000,
                type: "plant"
            },
            "Blighted_Jadeleaf": {
                name: "Blighted Jadeleaf",
                duration: 450000,
                type: "plant"
            },
            "False_Aggela": {
                name: "False Aggela",
                duration: 450000,
                type: "plant"
            },
            "Kalkonyx": {
                name: "Kalkonyx",
                duration: 62500,
                type: "mineral"
            },
            "Auronyx": {
                name: "Auronyx",
                duration: 100000,
                type: "mineral"
            },
            "Umbronyx": {
                name: "Umbronyx",
                duration: 220000,
                type: "mineral"
            },
            "Igneosite": {
                name: "Igneosite",
                duration: 450000,
                type: "mineral"
            },
            "Wulingstone": {
                name: "Wulingstone",
                duration: 450000,
                type: "mineral"
            },
        }
    },
    "RR": {
        name: "Reception Room",
        background: "rgba(124, 93, 163, 0.25)",
        border: "#6a4e8a",
        duration: 88000
    }
}

export default roomData;